import type { CSSProperties } from 'react'
import { formatTempo } from '@nextweight/shared'
import type { ForecastState } from '../../types'
import { useTranslation } from '../../lib/i18n'

interface BannerProps {
  state: ForecastState
}

export function Banner({ state }: BannerProps) {
  const { t } = useTranslation()

  if (state.status === 'WARMUP') {
    const left = state.meta.next_horizon_in ?? 0
    return (
      <div style={{ ...styles.root, ...styles.warmup }}>
        <div style={styles.heading}>{t('banner.warmup_title')}</div>
        <div style={styles.text}>
          {t('banner.warmup_text', { left })}
        </div>
      </div>
    )
  }

  if (state.status === 'PLATEAU') {
    const slope = state.current.tempo !== null ? state.current.tempo / 7 : 0
    return (
      <div style={{ ...styles.root, ...styles.plateau }}>
        <div style={styles.heading}>{t('banner.plateau_title')}</div>
        <div style={styles.text}>
          {t('banner.plateau_text', { tempo: formatTempo(slope) })}
        </div>
      </div>
    )
  }

  return null
}

const styles: Record<string, CSSProperties> = {
  root: {
    borderRadius: 12,
    padding: '14px 16px',
    margin: '8px 0',
  },
  warmup: {
    background: 'var(--tg-theme-secondary-bg-color, #f3f4f6)',
  },
  plateau: {
    background: '#fef3c7',
  },
  heading: {
    fontSize: 15,
    fontWeight: 600,
    color: 'var(--tg-theme-text-color, #000)',
    marginBottom: 4,
  },
  text: {
    fontSize: 14,
    lineHeight: 1.5,
    color: 'var(--tg-theme-hint-color, #666)',
  },
}
